var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCoin = function SvgCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coin_svg__Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 732.76 732.76"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".coin_svg__cls-2,.coin_svg__cls-3,.coin_svg__cls-5{stroke:#4d4c4c;stroke-linecap:round;stroke-linejoin:round;stroke-width:7.09px}.coin_svg__cls-2{fill:#b0d9c5}.coin_svg__cls-3{fill:#f4a49e}.coin_svg__cls-5{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    id: "coin_svg__logo_dark_mode",
    "data-name": "logo dark mode"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55 331.57v69.63c0 181.16 162.45 328.02 362.83 328.02S729.21 582.36 729.21 401.2v-69.63H3.55Z",
    style: {
      fill: "#fcc00f",
      stroke: "#4d4c4c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "7.09px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.38,
    cy: 331.57,
    rx: 362.83,
    ry: 328.02,
    style: {
      fill: "#ffe082",
      stroke: "#4d4c4c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "7.09px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.38,
    cy: 331.57,
    rx: 320.05,
    ry: 289.35,
    style: {
      stroke: "#4d4c4c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "7.09px",
      fill: "#ffd64f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "coin_svg__cls-5",
    d: "M683.62 560.51v-69.62M634.81 621.89v-69.62M586.01 662.32v-69.63M537.2 690.66v-69.75M488.4 710.21v-69.63M439.59 722.53v-69.62M390.78 726.13v-67.27M341.98 726.13v-67.27M293.17 722.54v-66.75M244.37 710.21v-66.55M195.56 690.66v-69.75M146.76 662.32v-69.63M97.95 621.89v-69.62M49.15 560.52v-69.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "coin_svg__cls-2",
    d: "M432.66 160.03c-7.13 19.6 2.97 41.25 22.56 48.38 19.59 7.13 41.25-2.96 48.38-22.56 4.28-11.77 5.54-33.04-.93-42.71l-31.35 21.03-10.49-36.26c-11.16 3.23-23.89 20.35-28.18 32.11ZM366.38 197.39l-5.1-17.94a38.981 38.981 0 0 0-26.84-26.84l-17.94-5.1 17.94-5.1a38.981 38.981 0 0 0 26.84-26.84l5.1-17.94 5.1 17.94a38.981 38.981 0 0 0 26.84 26.84l17.94 5.1-17.94 5.1a38.981 38.981 0 0 0-26.84 26.84l-5.1 17.94ZM299.26 160.03c7.13 19.6-2.97 41.25-22.56 48.38-19.59 7.13-41.25-2.96-48.38-22.56-4.28-11.77-5.54-33.04.93-42.71l31.35 21.03 10.49-36.26c11.16 3.23 23.89 20.35 28.18 32.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "coin_svg__cls-3",
    d: "M284.67 282.23s-70.97-45.35-170.39-8.06c0 0-13.52 119.84 87.11 146.84 123.02 33.01 83.29-138.78 83.29-138.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "coin_svg__cls-5",
    d: "M248.97 309.6s-38.13-29.22-99.39-11.47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "coin_svg__cls-3",
    d: "M448.1 282.23s70.97-45.35 170.39-8.06c0 0 13.52 119.84-87.11 146.84-123.02 33.01-83.29-138.78-83.29-138.78Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "coin_svg__cls-5",
    d: "M483.79 309.6s38.13-29.22 99.39-11.47"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "coin_svg__cls-3",
    cx: 365.96,
    cy: 380.34,
    rx: 164.58,
    ry: 155.87
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "coin_svg__cls-3",
    cx: 365.96,
    cy: 392.42,
    rx: 63.95,
    ry: 54.17
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "coin_svg__cls-5",
    d: "m268.12 343.79 3.2-3.51c7.69-8.43 20.37-10.02 29.9-3.75h0M429.12 336.53h0c9.53-6.27 22.21-4.68 29.9 3.75l3.2 3.51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "coin_svg__cls-3",
    d: "M341.32 406.63h0c-5.89 0-10.67-6.36-10.67-14.21h0c0-7.85 4.78-14.21 10.67-14.21h0c5.89 0 10.67 6.36 10.67 14.21h0c0 7.85-4.78 14.21-10.67 14.21ZM391.45 406.63h0c-5.89 0-10.67-6.36-10.67-14.21h0c0-7.85 4.78-14.21 10.67-14.21h0c5.89 0 10.67 6.36 10.67 14.21h0c0 7.85-4.78 14.21-10.67 14.21Z"
  }))));
};
export default SvgCoin;